import React from "react";
import { Stack, Typography, Chip, Box, Button } from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import SettingsIcon from "@mui/icons-material/Settings";

/**
 * Header del módulo de Inventario - Rediseñado 2024
 */
const InventoryHeader = ({ onManageLocations }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <Box
        sx={{
          bgcolor: "primary.main",
          color: "white",
          p: 1.5,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <InventoryIcon sx={{ fontSize: 32 }} />
      </Box>
      
      <Stack spacing={0.5} sx={{ flex: 1 }}>
        <Typography variant="h4" fontWeight={700} color="primary">
          Sistema de Inventario
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <WarehouseIcon fontSize="small" color="action" />
          <Typography variant="body2" color="text.secondary">
            Gestión integral de almacén y distribución a técnicos
          </Typography>
        </Stack>
      </Stack>
      
      <Stack direction="row" spacing={1}>
        {onManageLocations && (
          <Button
            variant="outlined"
            startIcon={<WarehouseIcon />}
            onClick={onManageLocations}
            size="small"
            sx={{ fontWeight: 600 }}
          >
            Gestionar Almacenes
          </Button>
        )}
        
        <Chip
          label="En Línea"
          color="success"
          size="small"
          sx={{ fontWeight: 600 }}
        />
      </Stack>
    </Stack>
  );
};

export default InventoryHeader;

